import { takeEvery } from "redux-saga/effects";
import { authorsListData, getAuthorInfoData, testimonialsData } from "./aboutSaga";
import {
  healthCheckApi,
  getLatestWorkApi,
  getGlobalSearchApi,
  createSubsribeUser,
} from "./homeSaga";
import {
  getArticlesListApi,
  getDynamicHeadingTextApi,
  getEngagementDetails,
  getEngagementsApi,
  getFilterListApi,
  getResearchAssessingApi,
  getResearchAssessingDetailsApi,
  getResearchStatisticsApi,
} from "./researchSaga";
import {
  getJaldiAspectsApi,
  getJaldiLabNotesApi,
  getJaldiLabDetailApiCall,
  getCollaboratorsListApi,
  getOrganisationListApi,
  getJaldiLabProjectListApi,
  getJaldiLabProjectDetailApi,
  getJaldiLabDetailedProjectVideoApi,
} from "./jaldiLabSaga";
import {
  getRtiTempletApi,
  getRtiTempletDetailApi,
  getRtiTempletMapDataApi,
} from "./jaldiPortalSaga";
import { getEventDetails } from "./eventSaga";
import {
  getArchiveHeadingTextApi,
  getConstiBenchMediaApi,
  getConstiBenchTextApi,
  getJudgesTypeDetailtApi,
  getJudgesTypeListApi,
  getJudicialTimeTrackerTextApi,
  getTimeTrackerViaYearApi,
} from "./constibenchSaga";
import {
  getOverAllDiversityDataApi,
  getOverAllDiversityFaqApi,
  getOverAllDiversityStatesListApi,
  getWomenInJudiciaryDataApi,
  getWomenInJudiciaryGraphDataApi,
  getWomenJudiciaryTextApi,
} from "./womenInJudiciarySaga";
import { getJudicialVacancyApiData } from "./judicialVacanySaga";
import { getBuildingBetterApiData, getBuildingBetterOverviewApiData } from "./buildingbetterSaga";
import { getVideoListApi } from "./videoSaga";

const watchUser = function* watchUser() {
  yield takeEvery("HEALTH_CHECK", healthCheckApi);
  yield takeEvery("GLOBAL_SEARCH", getGlobalSearchApi);
  yield takeEvery("SUBSCRIBE", createSubsribeUser);
  yield takeEvery("GET_AUTHORS_LIST_DATA", authorsListData);
  yield takeEvery("GET_TESTIMONIALS_DATA", testimonialsData);
  yield takeEvery("GET_AUTHOR_INFO", getAuthorInfoData);

  yield takeEvery("GET_ASSESSING_LIST", getResearchAssessingApi);

  yield takeEvery("GET_ARTICLES_LIST", getArticlesListApi);
  yield takeEvery("GET_FILTER_LIST", getFilterListApi);
  yield takeEvery("GET_RESEARCH_STATISTICS", getResearchStatisticsApi);

  // Research Details
  yield takeEvery("GET_ASSESSING_INFO", getResearchAssessingDetailsApi);

  yield takeEvery("GET_ENGAGMENTS_LIST", getEngagementsApi);
  yield takeEvery("GET_ENGAGEMENT_INFO", getEngagementDetails);

  // Dynamic Heading Text
  yield takeEvery("GET_HEADINGS_TEXTS", getDynamicHeadingTextApi);

  // Homepage latest work
  yield takeEvery("GET_LATEST_WORK", getLatestWorkApi);
  // Jaldi Aspects
  yield takeEvery("GET_JALDI_ASPECTS", getJaldiAspectsApi);
  // Jaldi Lab Notes
  yield takeEvery("GET_JALDI_LAB_NOTES", getJaldiLabNotesApi);
  // Jaldi Lab Notes Details
  yield takeEvery("GET_JALDI_LAB_DETAIL", getJaldiLabDetailApiCall);
  // Jaldi Lab collaborators List
  yield takeEvery("GET_COLLABORATOR_LIST", getCollaboratorsListApi);
  // Jaldi Lab organisation List
  yield takeEvery("GET_ORGANISATION_LIST", getOrganisationListApi);
  // Jaldi Lab organisation List
  yield takeEvery("GET_JALDI_PROJECT_LIST", getJaldiLabProjectListApi);
  // Jaldi Lab organisation List
  yield takeEvery("GET_JALDI_PROJECT_DETAIL", getJaldiLabProjectDetailApi);
  // RTI Templet
  yield takeEvery("GET_RTI_TEMPLET", getRtiTempletApi);
  // RTI Templet Detail
  yield takeEvery("GET_RTI_TEMPLET_DETAIL", getRtiTempletDetailApi);
  // RTI Templet Detail
  yield takeEvery("GET_RTI_TEMPLET_MAP_DATA", getRtiTempletMapDataApi);
  yield takeEvery("GET_EVENT_DETAIL", getEventDetails);
  yield takeEvery("GET_CONSTIBENCH_TEXT", getConstiBenchTextApi);
  yield takeEvery("GET_CONSTIBENCH_MEDIA", getConstiBenchMediaApi);
  yield takeEvery("GET_JUDGES_TYPE_LIST", getJudgesTypeListApi);
  yield takeEvery("GET_JUDGES_TYPE_DETAIL", getJudgesTypeDetailtApi);
  yield takeEvery("GET_JUDICIAL_TRACKER_TEXT", getJudicialTimeTrackerTextApi);
  yield takeEvery("GET_TIME_TRACKER_VIA_YEAR", getTimeTrackerViaYearApi);
  yield takeEvery("GET_ARCHIVE_HEADINGS_TEXTS", getArchiveHeadingTextApi);
  yield takeEvery("GET_HEADINGS_TEXTS_WOMEN_JUDICIARY", getWomenJudiciaryTextApi);
  yield takeEvery("GET_HIGH_SUPREME_COURT_DATA", getWomenInJudiciaryDataApi);
  yield takeEvery("GET_HIGH_SUPREME_COURT_DATA_GRAPH", getWomenInJudiciaryGraphDataApi);

  yield takeEvery("GET_OVERALL_GENDER_DIVERSITY_DATA", getOverAllDiversityDataApi);
  yield takeEvery("GET_OVERALL_GENDER_DIVERSITY_FAQ_DATA", getOverAllDiversityFaqApi);
  yield takeEvery("GET_OVERALL_GENDER_DIVERSITY_STATES_LIST", getOverAllDiversityStatesListApi);
  yield takeEvery("GET_JUDICIAL_VACANCY_DATA", getJudicialVacancyApiData);
  yield takeEvery("GET_BUILDING_BETTER_DATA", getBuildingBetterApiData);
  yield takeEvery("GET_COURT_DESIGN_HANDBOOK_VIDEO", getJaldiLabDetailedProjectVideoApi);
  yield takeEvery("GET_BUILDING_BETTER_COURTS_DATA_OVERVIEW", getBuildingBetterOverviewApiData);
  yield takeEvery("GET_VIDEO_LIST", getVideoListApi);
  yield takeEvery("GET_VIDEO_DETAILS", getVideoListApi);
};

const rootSaga = function* mySagas() {
  yield watchUser();
};

export default rootSaga;
